import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prod } from './slice/prod';
import ModalForm from '../common/cmpt/oneClick/ModalForm';

const Item = ({ prod: p, viewCmpt: ItemView }) => {
  const dispatch = useDispatch();
  const { cart, favour, compare } = useSelector((state) => state.prod);

  const { id, isPromo, newprod, showPrice, isAvailable, price } = p;

  let { multiplier } = p;
  multiplier = Number(multiplier);

  const hasTags = isPromo === true || newprod === true;
  const renderPrice = showPrice;
  const inStock = showPrice && isAvailable;
  const withPriceAndAvail = showPrice && price > 0;
  const inCart = cart.find(({ id: pId }) => pId === id);
  const inFavour = favour.find((pId) => pId === id);
  const inCompare = compare.find((pId) => pId === id);

  const [modal, setModal] = useState(false);
  const showModal = useCallback(() => setModal(true), [setModal]);
  const hideModal = useCallback(() => setModal(false), [setModal]);

  const data = {
    hasTags,
    renderPrice,
    inStock,
    withPriceAndAvail,
    inCart,
    inFavour,
    inCompare,

    showModal,
    hideModal,
    toggleFavour: () => dispatch(prod.actions.favour(id)),
    toggleCompare: () => dispatch(prod.actions.compare(id)),
    toCart: () => dispatch(prod.actions.addCartItem({ id, q: multiplier })),
  };

  return (
    <>
      <ItemView data={data} prod={p} />

      {modal && (
        <ModalForm prod={p} inStock={withPriceAndAvail} onHide={hideModal} />
      )}
    </>
  );
};

export default Item;
